import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { Button } from 'antd-mobile-v5';

const Welcome = (props: any) => {
    useEffect(() => {
        document.title =  "项目简介"
    }, [])

    const goHome = () => {
        let projectCodeQuery = new URLSearchParams(props.location.search).get('projectCode') as string
        props.history.replace('/epro/patient/home?projectCode=' + projectCodeQuery)
    }

    return (
        <div className={`${styles.container}`}>
            <p  className={styles.headerContent}>
                尊敬的先生/女士：
            </p>
           <p className={styles.content}>
                您好，感谢您参与本研究项目！本项目的主要目的为协助医生及时全面了解您治疗期间的身体情况。
             </p>

            <p className={styles.content}>
                参与过程中，研究者将按照临床规范治疗实践对您进行定期的治疗、检查、疗效评估、随访等，本研究方案未规定/强制进行研究访视或评价，仅进行相关信息的收集。拟收集的信息可来源于您或您的医生/护士。研究期间您需定期进行问卷的填写，本项目将通过短信或人工对您进行定期提醒以及回访，项目收集您研究期间的信息，让医生对您的相关情况进行评估。
            </p>

        
            <p className={styles.content}>
                感谢您的支持与配合，祝您早日康复！
            </p>
            <div className={styles.iframe_btn_wrap}>
                <Button shape="rounded" className={styles.iframe_btn_back} onClick={goHome} >
                    确定
                </Button>
            </div>
        </div>
    )
}

export default Welcome;